import Moment from "moment";
import React from "react";
import * as BS from "react-bootstrap";
import * as CopyToClipboard from "react-copy-to-clipboard";
import { connect } from "react-redux";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import { push } from "react-router-redux";
// import * as Share from "react-share";
import * as redux from "redux";
import * as Actions from "../../../actions";
import * as Comp from "../../../components";
import { Paths } from "../../../constants";
import { CareerCenterStatuses } from "../../../domain";
import * as M from "../../../models";
import { Api } from "../../../services/Api";
import { AppState } from "../../../store";
import { Utility } from "../../../utils";
import { CareerCenterHelper } from "../../../models/careerCenter/CareerCenterHelper";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    api: new Api(state),
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    goto: (url: string) => {
        dispatch(push(url));
    },
    notifyError: (message: string, icon?: string) => dispatch(Actions.Noti.notifyError(message, icon)),
});

type OwnProps = RouteComponentProps<{
    guid: string;
}> & {
};

interface ConnectedState {
    api: Api;
}

interface ConnectedDispatch {
    goto: (url: string) => void;
    notifyError: (message: string, icon?: string) => void;
}

interface OwnState {
    errors: string[];
    jobPost?: M.CareerCenter.JobPost;
    linkCopied: boolean;
}

type CombinedProps = ConnectedState & ConnectedDispatch & OwnProps;

class JobConfirmationComponent extends Comp.Base.BaseComponent<CombinedProps, OwnState> {

    public constructor(props: any) {
        super(props);
        this.state = {
            errors: [],
            linkCopied: false,
            loading: true,
        };
    }

    public async componentDidMount() {
        this._isMounted = true;

        const guid = this.props.match.params.guid;
        if (!guid) {
            this.setState({
                ...this.state,
                errors: ["Job post identifier is missing in URL (guid)"],
            });
            return;
        }

        const qp = { queryParams: { guid } };
        const result = await this.props.api.get<M.CareerCenter.JobPost>(Api.endpoints.users.careerCenter.job, qp);

        if (!this._isMounted)
            return;

        if (result.isSuccess && result.data) {
            if (result.data.statusId === CareerCenterStatuses.Created.id) {
                this.props.notifyError("The requested job post has not been posted yet.");
                this.props.goto(Paths.CareerCenter.Job.Review + "/" + guid);
                return;
            }

            this.setState({
                ...this.state,
                jobPost: result.data,
            });
        }
        else {
            const errors =  M.Result.Result.errorsOrMessage(result);
            this.setState({
                ...this.state,
                errors,
            });
        }

        this.toggleLoading(false);
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    public render() {
        let details = null;

        if (this.state.errors.length) {
            details = <BS.Alert bsStyle="warning">
                <h3>The requested job post could not be retrieved.</h3>
                <ul>
                    {this.state.errors.map((e, i) => (<li key={i}>{e.toString()}</li>))}
                </ul>
            </BS.Alert>;
        }
        else if (this.state.jobPost) {
            const job = this.state.jobPost;
            const host = Utility.getUrlBase(this.props.match.url, true);
            const detailsUrl = `${host}${CareerCenterHelper.jobDetailsLink(job)}`;
            const expiresOn = Utility.utcToLocal(Utility.fromApiDate(job.expiresOn) || new Date());
            const confNumber = Utility.padText(job.id.toString(), "0", 6);
            const copyButton = this.state.linkCopied
                ? <BS.Button bsStyle="primary"><Comp.Generic.Icon icon="check" /> Link copied</BS.Button>
                : <BS.Button bsStyle="primary"><Comp.Generic.Icon icon="copy" /> Copy link</BS.Button>;

            details = <div>
                <h1>Confirmation</h1>
                <h2>Your job has been posted!</h2>
                <p>
                    Confirmation #{confNumber}. A confirmation email was sent to <strong>{job.postedBy.username}</strong>.{" "}
                    <Link to={CareerCenterHelper.jobDetailsLink(job)}>View your listing &raquo;</Link>
                    <br /><br />
                    Listing expires <strong>{Moment(expiresOn).format("MMMM D, YYYY")}</strong>.
                    You will receive an email notification 10 days prior to expiration with the option to renew.
                    <br />You may deactivate or edit your listing anytime via <Link to={Paths.User.CareerCenter.Jobs}>Your Listings</Link>.
                </p>

                <h3>Share your listing</h3>

                <BS.InputGroup>
                    <BS.FormControl value={detailsUrl} readOnly />
                    <span className="input-group-btn">
                        <CopyToClipboard text={detailsUrl} onCopy={() => this.setState({ ...this.state, linkCopied: true })}>
                            {copyButton}
                        </CopyToClipboard>
                    </span>
                </BS.InputGroup>

                <br />
                <Comp.Generic.AddThis url={detailsUrl} />
                <br />

                <h2><Link to={Paths.CareerCenter.Job.Post}>Post a new listing &raquo;</Link></h2>
            </div>;
        }

        return <Comp.Page.PublicPage pageTitle="Job post confirmation" style={{position: "relative", minHeight: "300px"}}>
            <Comp.Generic.LoadingSpinner show={this.state.loading} />
            {details}
        </Comp.Page.PublicPage>;
    }
}

export const JobConfirmation: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(withRouter(JobConfirmationComponent) as any);



// WEBPACK FOOTER //
// ./src/containers/careerCenter/jobConfirmation/JobConfirmation.tsx